import api from './api'

export const authService = {
  login: async (email, password) => {
    const res = await api.post('/auth/login', { email, password })
    return res.data.data
  },

  logout: async () => {
    await api.post('/auth/logout')
  },

  refreshToken: async (refreshToken) => {
    const res = await api.post('/auth/refresh', { refreshToken })
    return res.data.data
  },

  forgotPassword: async (email) => {
    const res = await api.post('/auth/forgot-password', { email })
    return res.data
  },

  resetPassword: async (token, password) => {
    const res = await api.post('/auth/reset-password', { token, password })
    return res.data
  },

  getMe: async () => {
    const res = await api.get('/users/me')
    return res.data.data
  },
}
